import { CLIENTS } from "../data/site";

// Continuous, always-visible client logo marquee (two tracks for seamless loop).
export const LogoMarquee = () => {
  const row = (keyPrefix) => (
    <div className="flex shrink-0">
      {CLIENTS.map((c, i) => (
        <div key={`${keyPrefix}-${i}`} className="flex items-center justify-center px-8 md:px-12 shrink-0">
          <img
            src={c.logo}
            alt={c.name}
            title={c.name}
            loading="lazy"
            draggable="false"
            className="h-10 md:h-12 w-auto max-w-[150px] object-contain opacity-90 hover:opacity-100 transition-opacity duration-300"
          />
        </div>
      ))}
    </div>
  );

  return (
    <section data-testid="home-client-strip" className="bg-white border-y border-dark-text/10 py-8 md:py-10">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <p className="font-mono text-[10px] md:text-[11px] tracking-[0.24em] uppercase text-dark-text/45 text-center mb-8">
          Trusted by brands we've helped grow
        </p>
      </div>
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex w-max animate-marquee">
          {row("a")}
          {row("b")}
        </div>
      </div>
    </section>
  );
};
